export const PAGE_NAME = 'PAGE_NAME'
